<template>
  <transition name="modal">
    <div v-if="QR_STATE.show" class="modal">
      <div id="qr-code" class="modal-guts">
        <div class="qr-code--container">
          <div class="qr-code--frame">
            <div class="qr-code--letter">
              <span>{{ PROJECT_INFO.name && PROJECT_INFO.name.charAt(0) }}</span>
              <div
                v-if="PROJECT_INFO.attachment"
                class="background cover"
                :style="{ backgroundImage: `url(${PROJECT_INFO.attachment.link})` }"
              ></div>
            </div>
            <div class="qr-code--title">
              <span v-text="PROJECT_INFO.name"></span>
            </div>
            <div class="qr-code--code" :class="!qr && 'rotating'">
              <img
                v-if="qr"
                :src="qr"
                :alt="$t('qr.code')"
              />
            </div>
            <div class="qr-code--data">
              <span
                v-if="displayAmount"
                v-text="displayAmount"
              ></span>
              <br />
              <span
                v-if="QR_STATE.bill.description"
                v-text="QR_STATE.bill.description"
              ></span>
            </div>
            <div
              class="qr-code--button figure"
              @click="SET_MODAL_PARAMS({ type: 'QR', params: { show: false } })"
            >
              <button
                class="icon"
                v-text="$t('common.close')"
              ></button>
            </div>
          </div>
          <div class="qr-code--description">
            <span v-html="$t('scan.qr.for.pay')"></span>
          </div>
          <div class="qr-code--buttons">
            <a class="button thin clear" @click="onDownload">
              <span>{{ $t('download.svg') }}</span>
            </a>
            <!-- CPME-4535: fix done -->
            <!-- <a class="button thin clear" @click="print('qr-code-small')">
              <span>{{ $t('qr.visiting.card') }}</span>
            </a>
            <a class="button thin clear" @click="print('qr-code-large')">
              <span>{{ $t('qr.on.sheet') }}</span>
            </a> -->
          </div>
          <div class="qr-code--logo">
            <img src="~@/assets/img/logo-brand-colored.svg" alt="Capusta Logo" />
          </div>
        </div>
      </div>

      <!-- CPME-4535: fix done -->
      <!-- <print-cabinet-qr-code-small
        :project-info="PROJECT_INFO"
        :qr="qr"
        :qr-state="QR_STATE"
        class="hide"
      />
      <print-cabinet-qr-code-large
        :project-info="PROJECT_INFO"
        :qr="qr"
        :qr-state="QR_STATE"
        class="hide"
      /> -->
    </div>
  </transition>
</template>

<script>
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { mapState, mapMutations } from 'vuex';
import { Printd } from 'printd';

import { formatAmount } from 'lib/utils/amount';

import HTTPService from '@/services/Http';
import TransactionService from 'services/transaction';

// import PrintCabinetQrCodeLarge from '@/components/prints/PrintCabinetQRCodeLarge';
// import PrintCabinetQrCodeSmall from '@/components/prints/PrintCabinetQRCodeSmall';

const QR_SMALL = '*{-webkit-box-sizing:border-box;box-sizing:border-box}body{font:14pt Montserrat,sans-serif;line-height:1.4;background:#fff!important;color:#000;text-align:center}p{margin:0}.background.cover{position:absolute;display:block;overflow:hidden;top:0;left:0;width:100%;height:100%;z-index:1;border-radius:50%;background-position:50% 50%;background-repeat:no-repeat;background-size:cover;-webkit-filter:grayscale(1);filter:grayscale(1)}#qr-code-small .qr-code--code img{max-width:3.2cm;margin:.3cm 0;height:auto;position:relative;z-index:1}#qr-code-small .qr-code--code{margin:.4cm auto 0;display:inline-block;padding:0;border:.2mm solid #000;border-radius:.2cm;position:relative;width:calc(100% - .4mm)}#qr-code-small .qr-code--code:after{content:"";position:absolute;top:.4cm;bottom:.4cm;background-color:#FFF;left:-.5mm;right:-.5mm}#qr-code-small .qr-code--code:before{content:"";position:absolute;top:-.5mm;bottom:-.5mm;background-color:#FFF;left:.4cm;right:.4cm}#qr-code-small .qr-code--container{max-width:5cm;margin:0 auto;padding-top:2cm}#qr-code-small .qr-code--data span{color:#000;display:inline-block;margin:.4cm 0}#qr-code-small .qr-code--data span:first-of-type{font-weight:500;font-size:.36cm;line-height:126%}#qr-code-small .qr-code--data span:last-of-type{margin-top:.1cm;font-size:.18cm;line-height:146.3%;word-break:break-all}#qr-code-small .qr-code--data{position:relative;min-height:1cm;margin-top:-.6cm;z-index:1}#qr-code-small .qr-code--footer img{width:1cm;height:auto;top:2mm;right:.4cm;position:absolute}#qr-code-small .qr-code--footer p{font-size:.14cm;padding-top:.3cm;padding-bottom:.3cm}#qr-code-small .qr-code--footer{background-color:transparent;color:#535353;position:relative;width:calc(100% + (.4cm * 2));left:-.4cm;margin-bottom:-.4cm;border-radius:0 0 .2cm .2cm;padding:0 .4cm;text-align:left}#qr-code-small .qr-code--frame{position:relative;background-color:#FFF;border-radius:.2cm;padding:.4cm;border:.2mm dashed rgba(0,0,0,0.25)}#qr-code-small .qr-code--header{text-align:left;position:relative;display:-webkit-box;display:-ms-flexbox;display:flex}#qr-code-small .qr-code--hints img{width:3.8cm;height:auto}#qr-code-small .qr-code--hints span{font-size:0}#qr-code-small .qr-code--hints{margin:.2cm 0}#qr-code-small .qr-code--letter span{color:#FFF;line-height:0}#qr-code-small .qr-code--letter{color-adjust:exact!important;print-color-adjust:exact!important;-webkit-print-color-adjust:exact!important;text-align:center;font-size:.36cm;line-height:.7cm;width:.7cm;height:.7cm;background-color:#212121;border-radius:50%;position:relative}#qr-code-small .qr-code--line{border:0;margin:0;height:0;border-top:.2mm solid #BFBFBF;background-color:unset}#qr-code-small .qr-code--title span{word-break:break-all}#qr-code-small .qr-code--title{font-size:.24cm;line-height:.3cm;color:#000;-ms-flex-item-align:center;-ms-grid-row-align:center;align-self:center;margin-left:.2cm;-ms-flex-preferred-size:calc(100% - (.7cm + .2cm));flex-basis:calc(100% - (.7cm + .2cm))}#qr-code-small{position:absolute;top:0;left:0;width:auto;width:100%;left:50%;top:50%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%);height:100%;overflow:auto}@media print{@page{size:auto;margin:0}}';

const QR_LARGE = '*{-webkit-box-sizing:border-box;box-sizing:border-box}@page{size:landscape;margin:0}body{font:14pt Montserrat,sans-serif;line-height:1.4;background:#fff!important;color:#000;text-align:center}p{margin:0}.background.cover{position:absolute;display:block;overflow:hidden;top:0;left:0;width:100%;height:100%;z-index:1;border-radius:50%;background-position:50% 50%;background-repeat:no-repeat;background-size:cover;-webkit-filter:grayscale(1);filter:grayscale(1)}#qr-code-large .qr-code--code img{max-width:9cm;margin:1cm 0;height:auto;position:relative;z-index:1}#qr-code-large .qr-code--code{display:inline-block;border:.2mm solid #000;border-radius:.6cm;position:relative;width:calc(100% - .2mm);max-height:calc(9cm + (1cm * 2))}#qr-code-large .qr-code--code:after{content:"";position:absolute;top:1.4cm;bottom:1.4cm;background-color:#FFF;left:-.1cm;right:-.1cm}#qr-code-large .qr-code--code:before{content:"";position:absolute;top:-.1cm;bottom:-.1cm;background-color:#FFF;left:1.4cm;right:1.4cm}#qr-code-large .qr-code--container{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}#qr-code-large .qr-code--data span{color:#000;display:block}#qr-code-large .qr-code--data span:first-of-type{font-weight:500;font-size:1.44cm;line-height:126%;margin:1cm 0 .65cm}#qr-code-large .qr-code--data span:last-of-type{font-size:.36cm;line-height:146.3%;margin:0 0 3cm;word-break:break-all}#qr-code-large .qr-code--data{position:relative;min-height:6cm;margin:0 1cm}#qr-code-large .qr-code--footer img{width:3cm;height:auto;bottom:0;right:.4cm;position:absolute}#qr-code-large .qr-code--footer{color:#535353;position:relative;text-align:left}#qr-code-large .qr-code--frame-left,#qr-code-large .qr-code--frame-right{-ms-flex-preferred-size:50%;flex-basis:50%}#qr-code-large .qr-code--frame-right{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}#qr-code-large .qr-code--hints img{width:8.4cm;height:auto}#qr-code-large .qr-code--hints span{font-size:0}#qr-code-large .qr-code--letter span{color:#FFF}#qr-code-large .qr-code--letter{font-size:.96cm;line-height:.117cm;width:3cm;height:3cm;background-color:#212121;border-radius:50%;position:relative;left:50%;-webkit-transform:translate(-50%,0);-ms-transform:translate(-50%,0);transform:translate(-50%,0);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}#qr-code-large .qr-code--line{border:0;margin:0 1cm;height:0;border-top:.2mm solid #BFBFBF;background-color:transparent}#qr-code-large .qr-code--title span{display:block;word-break:break-all}#qr-code-large .qr-code--title{font-size:.72cm;line-height:.88cm;color:#000;-ms-flex-item-align:center;-ms-grid-row-align:center;align-self:center;margin:1cm 0 1.5cm}#qr-code-large{position:absolute;width:auto;width:100%;overflow:hidden;padding:2cm 1cm;-webkit-filter:grayscale(1);filter:grayscale(1)}@media print{#qr-code-large .qr-code--letter{color-adjust:exact!important;print-color-adjust:exact!important;-webkit-print-color-adjust:exact!important}}';

export default {
  name: 'ModalCabinetQrCode',
  // components: {
  //   PrintCabinetQrCodeLarge,
  //   PrintCabinetQrCodeSmall,
  // },
  data() {
    return {
      qr: '',
    };
  },
  computed: {
    currency() {
      return this.PROJECT_INFO.currency;
    },
    billTariffs() {
      return this.QR_STATE.bill?.billTariffs || [];
    },
    tariff() {
      if (this.$validate.isEmptyArray(this.billTariffs)) {
        return null;
      }

      return TransactionService.getBillTariffWithMinAmount(this.QR_STATE.bill);
    },
    displayAmount() {
      if (this.QR_STATE.bill.amount) {
        return formatAmount(this.QR_STATE.bill.amount, this.currency);
      }

      // Если qr-code не принадлежит счетам
      if (this.$validate.isNull(this.tariff)) {
        return null;
      }

      // Если счет без указания валюты
      if (this.$validate.isNull(this.tariff.amount)) {
        return null;
      }

      // Если в счете только один вриант тарифа
      if (this.$validate.isFixedLengthArray(this.billTariffs, 1)) {
        return formatAmount(this.tariff.amount, this.tariff.currency);
      }

      // Если в счете несколько вариантов тарифов
      return this.$t('amount.from', {
        displayAmount: formatAmount(this.tariff.amount, this.tariff.currency),
      });
    },
    ...mapState({
      PROJECT_INFO: 'PROJECT_INFO',
      QR_STATE: state => state.MODALS.QR,
    }),
  },
  watch: {
    QR_STATE: {
      deep: true,
      handler(value) {
        if (!value.show) {
          enableBodyScroll(document.body);
          return;
        }

        disableBodyScroll(document.body);
        this.qr = '';

        this.fetchQRCode(value);
      },
    },
  },
  methods: {
    print(id) {
      const el = document.getElementById(id);
      const css = id === 'qr-code-small' ? QR_SMALL : QR_LARGE;

      new Printd().print(el, [css]);
    },
    async fetchQRCode(value) {
      const preparedType = value.type.toUpperCase();
      const preparedCode = String(value.code);

      try {
        const { data, headers } = await HTTPService.fetchQRCode('SVG', preparedType, preparedCode);
        const blob = new Blob([data], {
          type: headers['content-type'],
        });

        this.qr = URL.createObjectURL(blob);
      } catch (error) {
        this.$alert({
          type: 'warning',
          text: 'qr.code.not.loaded',
        });

        this.SET_MODAL_PARAMS({
          type: 'QR',
          params: {
            show: false,
          },
        });
      }
    },
    async onDownload() {
      const link = document.createElement('a');

      link.setAttribute('href', this.qr);
      link.setAttribute('download', 'qr-code.svg');
      document.body.appendChild(link);

      link.click();
      link.remove();
    },
    ...mapMutations(['SET_MODAL_PARAMS']),
  },
};
</script>

<style lang="sass" scoped>
.hide
  position: absolute
  left: -9999px !important
  opacity: 0
@keyframes rotating
  from
    transform: rotate(0deg)
  to
    transform: rotate(360deg)

.modal
    /* This way it could be display flex or grid or whatever also. */
    display: block

    /* Probably need media queries here */
    // width: 600px
    width: 100%
    max-width: 100%

    // height: 400px
    height: 100%
    max-height: 100%

    position: fixed

    z-index: 2000

    left: 50%
    top: 50%

    /* Use this for centering if unknown width/height */
    transform: translate(-50%, -50%)

    /* If known, negative margins are probably better (less chance of blurry text). */
    /* margin: -200px 0 0 -200px; */

    // background-color: #1E1D2F
    .eclipse &
      background-color: #F5F5F5
    .obsidian &
      background-color: #1E1D2F
    // #{theme('eclipse')} &
    // #{theme('obsidian')} &
    // box-shadow: 0 0 60px 10px rgba(0, 0, 0, 0.9)
    // opacity: 1
    // transition: opacity .2s
    // &.fade
        // opacity: 0
.modal-guts
    -webkit-overflow-scrolling: touch // fix it alll
    position: absolute
    top: 0
    left: 0
    width: auto
    // max-width: 42rem
    width: 100%

    left: 50%
    top: 50%

    /* Use this for centering if unknown width/height */
    transform: translate(-50%, -50%)
    height: 100%
    overflow: auto

    // padding: 0 2.48rem
    padding: 0 1.28rem
// #qr-code
//     position: fixed
//     top: 50%
//     left: 50%
//     transform: translate(-50%, -50%)
//     z-index: 10
//     background-color: #181822
//     padding: 10rem
#qr-code
    padding-top: 6rem
    text-align: center
    background: var(--color-bg-default)
    .qr-code--container
        max-width: 36rem
        margin: 0 auto
    .qr-code--frame
        position: relative
        .eclipse &
          background-color: #E5E5E5
        .obsidian &
          background-color: #181822
        border-radius: .64rem
        padding: 1.28rem
        @media (min-width: 64rem)
            padding: 2.24rem
    .qr-code--letter
        font-size: 36px
        line-height: 44px
        width: 6rem
        height: 6rem
        .eclipse &
          background-color: #212121
        .obsidian &
          background-color: #FFFFFF
        border-radius: 50%
        position: absolute
        top: 0rem
        left: 50%
        transform: translate(-50%, -50%)
        span
            .eclipse &
              color: #FFFFFF
            .obsidian &
              color: #212121
            line-height: 6rem
    .qr-code--title
        font-size: 24px
        line-height: 30px
        margin-top: 3rem
        .eclipse &
          color: #212121
        .obsidian &
          color: #FFFFFF
        @media (min-width: 64rem)
            font-size: 36px
            line-height: 44px
    .qr-code--code
        margin-top: 3rem
        display: inline-block
        padding: 1.2rem
        .eclipse &
          border: .08rem solid #212121
        .obsidian &
          border: .08rem solid #FFFFFF
        border-radius: 1.48rem
        position: relative
        transition: all .6s ease
        &.rotating
            padding: 1.1rem
            animation: rotating 1s linear infinite
        &:before
            // @include pseudo-block
            content: ""
            position: absolute
            top: -.16rem
            bottom: -.16rem
            // background-color: #181822
            .eclipse &
              background-color: #E5E5E5
            .obsidian &
              background-color: #181822
            left: 2.24rem
            right: 2.24rem
        &:after
            // @include pseudo-block
            content: ""
            position: absolute
            top: 2.24rem
            bottom: 2.24rem
            // background-color: #181822
            .eclipse &
              background-color: #E5E5E5
            .obsidian &
              background-color: #181822
            left: -.16rem
            right: -.16rem

        +respond-to(medium)
          padding: 2rem

        img
          position: relative
          display: block
          height: 200px
          padding: 10px
          border-radius: 10px
          // filter: invert(1)
          background-color: #FFFFFF
          z-index: 1

          +respond-to(medium)
            height: 220px
            padding: 20px
            border-radius: 20px

    .qr-code--data
        margin-top: 3rem
        margin-bottom: 1rem
        span
            max-width: 100%
            word-break: break-all
            .eclipse &
              color: #212121
            .obsidian &
              color: #FFFFFF
            display: inline-block
            margin: .64rem 0
            &:first-of-type
                font-weight: 500
                font-size: 24px
                line-height: 126%
                @media (min-width: 64rem)
                    font-size: 36px
            &:last-of-type
                font-size: 14px
                line-height: 146.3%
                @media (min-width: 64rem)
                    font-size: 18px
    .qr-code--button
        position: absolute
        top: .16rem
        right: .16rem
        @media (min-width: 64rem)
            top: 0
            right: 0
            transform: translate(50%, -50%)
        button
            font-size: 0
            width: 2rem
            height: 2rem
            background-color: transparent
            .eclipse &
              background-image: url(~@/assets/img/icon-x--black.svg)
            .obsidian &
              background-image: url(~@/assets/img/icon-x--white.svg)
            background-size: contain
            &:hover
                background-image: url(~@/assets/img/icon-x--special.svg)
    .qr-code--description
        color: #999999
        margin: 3rem 0
    .qr-code--buttons
        margin: 3rem 0
        @media (min-width: 64rem)
            display: flex
            justify-content: center
        a
            margin: .32rem 0
            @media (min-width: 64rem)
                margin: 0
            &:hover
                // color: #FFFFFF
        @media (min-width: 64rem)
            a
                width: 30%
                padding: 10px 0
    .qr-code--logo
        margin: 3rem 0
        img
            width: 6rem
            height: auto
</style>
